<main class="home">

  <!-- هیرو -->
  <section class="hero" id="price">
    <div class="hero-grid">
      <div class="hero-lead">
        <span class="badge">با نظارت وزارت صمت · نگهداری در بانک ملی</span>
        <h1 class="hero-title">طلای آب‌شده، <em>آنلاین</em> و لحظه‌ای.</h1>
        <p class="hero-sub">
          از هر جای ایران، با هر سرمایه‌ای. خرید و فروش لحظه‌ای طلای آب‌شدهٔ ۷۵۰، با امکان تحویل فیزیکی شمش
          هولوگرام‌دار.
        </p>
        <div class="hero-cta">
          <a class="btn-gold" [href]="registerHref" target="_blank" rel="noopener">ورود | ثبت نام</a>
        </div>
      </div>
      <div class="hero-chart">
        <app-price-card></app-price-card>
      </div>
    </div>

    <div class="hero-stats" #stats>
      <div class="stat">
        <b class="counter">
          <span class="counter-sizer" aria-hidden="true">۱۸۸٬۸۸۸+</span>
          <span>{{ activeUsers() }}</span>
        </b>
        <span>کاربر فعال</span>
      </div>
      <div class="divline" aria-hidden="true"></div>
      <div class="stat">
        <b>{{ tonsTraded() }}</b>
        <span>تن طلای معامله‌شده</span>
      </div>
      <div class="divline" aria-hidden="true"></div>
      <div class="stat">
        <b class="plain">۱۳۹۸</b>
        <span>سال تأسیس</span>
      </div>
      <div class="divline" aria-hidden="true"></div>
      <div class="stat">
        <b class="plain">۲۴/۷</b>
        <span>پایش امنیتی</span>
      </div>
    </div>
  </section>

  <!-- نوار اعتماد -->
  <section class="trust reveal" aria-label="مجوزها و نظارت">
    <p class="trust-label">مورد اعتماد و تحت نظارت نهادهای رسمی</p>
    <div class="trust-row">
      @for (item of trustItems; track item.label) {
        <div class="trust-item">
          <app-icon [name]="item.icon" [size]="18"></app-icon>
          <span>{{ item.label }}</span>
        </div>
      }
    </div>
  </section>

  <!-- معرفی و ویدیو -->
  <section class="intro-sec reveal" id="about">
    <div class="intro-grid">
      <div class="intro-copy">
        <img class="intro-logo" src="/images/home/logo-wordmark.webp" alt="بازر" width="132" height="76"
             loading="lazy">
        <p>بازر اولین اپلیکیشن خرید و فروش آنلاین طلا است؛ از سال ۱۳۹۸ خرید و فروش طلای آب‌شده را به‌صورت آنلاین
          و برای هر سطح از توان مالی فراهم کرده است.</p>
        <p>با نظارت وزارت صمت، طلای شما در کارگشایی بانک ملی نگهداری می‌شود تا بدون دغدغه و با اطمینان خاطر
          سرمایه‌گذاری کنید.</p>
        <p>نرم‌افزار و سخت‌افزار بازر به‌گونه‌ای طراحی شده که امکان دخل و تصرف، تقلب و حملهٔ سایبری را به صفر
          رسانده؛ تیمی نیز به‌صورت ۲۴ ساعته زیرساخت‌های فنی را رصد می‌کند.</p>
        <p>قیمت طلا در بازر به‌صورت لحظه‌ای با بازار طلای تهران تنظیم می‌شود تا بتوانید به‌صورت آنی طلا خرید و
          فروش کنید.</p>
        <p>اپلیکیشن بازر محصول شرکت نوآفرینان طلا و جواهر چشم انداز است و همواره برای تجربهٔ کاربری بهتر
          به‌روزرسانی می‌شود.</p>
      </div>

      <div class="intro-video">
        <div class="video-slider">
          <div class="video-track-clip">
            <div class="video-track" [style.transform]="'translateX(' + (-videoIndex() * 100) + '%)'">
              @for (v of videos; track v.src; let i = $index) {
                <div class="video-slide">
                  <div class="video-frame" [class.has-video]="playing() === i">
                    <video #player controls playsinline preload="none" [src]="v.src" [attr.aria-label]="v.title"></video>
                    <button type="button" class="video-ph" (click)="playVideo(i, player)">
                      <span class="video-play" aria-hidden="true"></span>
                      <b>{{ v.title }}</b>
                      <span class="video-note">{{ v.note }}</span>
                    </button>
                  </div>
                </div>
              }
            </div>
            @if (videos.length > 1) {
              <button type="button" class="vslider-arrow vslider-prev" (click)="goVideo(videoIndex() - 1)"
                      aria-label="ویدیوی قبلی">
                <app-icon name="chevron-right" [size]="18"></app-icon>
              </button>
              <button type="button" class="vslider-arrow vslider-next" (click)="goVideo(videoIndex() + 1)"
                      aria-label="ویدیوی بعدی">
                <app-icon name="chevron-left" [size]="18"></app-icon>
              </button>
            }
          </div>
          @if (videos.length > 1) {
            <div class="vslider-dots">
              @for (v of videos; track v.src; let i = $index) {
                <button type="button" class="vslider-dot" [class.active]="i === videoIndex()"
                        (click)="goVideo(i)" [attr.aria-label]="'اسلاید ' + (i + 1)"></button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- ویژگی‌ها -->
  <section class="features reveal" id="features">
    <div class="sec-head">
      <span class="kicker">چرا بازر</span>
      <h2>یک پلتفرم، تمام چرخهٔ طلا</h2>
      <p>از خرید لحظه‌ای تا تحویل فیزیکی شمش هولوگرام‌دار — همه‌چیز شفاف، امن و آنلاین.</p>
    </div>
    <div class="feat-grid">
      @for (f of features; track f.title) {
        <div class="feat-cell">
          <span class="feat-icon">
            <app-icon [name]="f.icon" [size]="26"></app-icon>
          </span>
          <h3>{{ f.title }}</h3>
          <p>{{ f.body }}</p>
        </div>
      }
    </div>
  </section>

  <!-- تحویل فیزیکی -->
  <section class="split reveal" id="delivery">
    <div class="split-media">
      <div class="holo-card">
        <plaque-3d class="holo-slot" texture="/images/home/plaque-texture.webp"
                   fallback="/images/home/delivery-plaque.webp"
                   fallback-alt="پلاک ۲٫۵ گرمی طلای ۷۵۰ بازر در بسته‌بندی پلمب‌شده"></plaque-3d>
        <div class="holo-badge"><span class="holo-chip" aria-hidden="true"></span>هولوگرام اصالت</div>
      </div>
    </div>
    <div class="split-copy">
      <span class="kicker">تحویل فیزیکی</span>
      <h2>طلای خریداری‌شده را در بسته‌بندی هولوگرام‌دار تحویل بگیرید</h2>
      <p>هر زمان بخواهید، طلای آب‌شدهٔ شما به‌صورت پلاک یا شمش، در بسته‌بندی پلمب و هولوگرام اصالت، به‌صورت حضوری
        یا نیابتی تحویل داده می‌شود.</p>
      <ul class="ticks">
        @for (t of deliveryTicks; track t) {
          <li>{{ t }}</li>
        }
      </ul>
      <a class="btn-gold" [href]="registerHref" target="_blank" rel="noopener">درخواست تحویل فیزیکی</a>
    </div>
  </section>

  <!-- نگهداری امن -->
  <section class="split reverse reveal" id="vault">
    <div class="split-media">
      <vault-shield-3d class="vault-shield" fallback="/images/home/vault-shield.webp"
                       fallback-alt="نشان خزانهٔ امن بازر"></vault-shield-3d>
    </div>
    <div class="split-copy">
      <span class="kicker">نگهداری امن</span>
      <h2>طلای شما، در امن‌ترین خزانهٔ کشور</h2>
      <p>تا زمانی که تصمیم به تحویل یا فروش بگیرید، طلای شما با نظارت وزارت صمت در خزانهٔ بانک ملی نگهداری
        می‌شود. ساختار نرم‌افزاری و سخت‌افزاری بازر امکان هرگونه دخل، تصرف یا حملهٔ سایبری را به صفر رسانده
        است.</p>
      <div class="mini-stats">
        <div><b>۱۰۰٪</b><small>پشتوانهٔ طلای فیزیکی</small></div>
        <div><b>۲۴/۷</b><small>پایش امنیتی</small></div>
        <div><b>۰</b><small>مورد نقض امنیتی</small></div>
      </div>
    </div>
  </section>

  <!-- ماشین‌حساب -->
  <section class="calc reveal" id="calc">
    <div class="calc-inner">
      <div class="sec-head">
        <span class="kicker">محاسبه‌گر</span>
        <h2>اگه طلا خریده بودم...</h2>
        <p>ببینید اگر چند وقت پیش در بازر طلا خریده بودید، سرمایه‌تان امروز چقدر می‌ارزید.</p>
      </div>
      <app-benefit-calc></app-benefit-calc>
    </div>
  </section>

  <!-- چهار قدم عضویت -->
  <section class="steps reveal" id="signup">
    <header class="steps-head">
      <span class="kicker">شروع کار</span>
      <h2>در چهار قدم، عضو بازر شوید</h2>
      <div class="steps-wedge" aria-hidden="true">
        <svg viewBox="0 0 220 34" preserveAspectRatio="none">
          <path d="M2 2 L110 26 L218 2" fill="none" stroke="var(--gold-500)" stroke-width="3" stroke-linecap="round"/>
          <path d="M2 13 L110 32 L218 13" fill="none" stroke="var(--gold-700)" stroke-width="2" stroke-linecap="round"
                opacity=".7"/>
        </svg>
      </div>
      <p>کل مسیر از ثبت‌نام تا اولین خرید حدود پنج دقیقه زمان می‌برد و همه‌چیز آنلاین است.</p>
    </header>
    <div class="step-body">
      <div class="step-rail" aria-hidden="true">
        <span class="step-rail-fill" [style.width.%]="activeStep() / (steps.length - 1) * 100"></span>
      </div>
      <ol class="step-track">
        @for (s of steps; track s.title; let i = $index) {
          <li class="step" [class.is-active]="i === activeStep()" [class.is-done]="i < activeStep()"
              (mouseenter)="pickStep(i)" (click)="pickStep(i)">
            <span class="step-dot"><b>{{ (i + 1).toLocaleString('fa-IR') }}</b></span>
            <span class="step-ic">
              <app-icon [name]="s.icon" [size]="22"></app-icon>
            </span>
            <h3>{{ s.title }}</h3>
            <p>{{ s.body }}</p>
            <span class="step-time">{{ s.time }}</span>
          </li>
        }
      </ol>
    </div>
  </section>

  <!-- اپلیکیشن -->
  <section class="app reveal" id="app">
    <div class="app-copy">
      <span class="kicker">اپلیکیشن بازر</span>
      <h2>کل بازار طلا، در جیب شما</h2>
      <p>قیمت لحظه‌ای، خرید و فروش، تحویل فیزیکی و گزارش دارایی — همه در یک اپلیکیشن امن و سریع.</p>
      <ul class="ticks">
        @for (t of appTicks; track t) {
          <li>{{ t }}</li>
        }
      </ul>
      <div class="store-row">
        <a class="store" href="https://cafebazaar.ir/app/com.baazarplus.app" target="_blank" rel="noopener noreferrer">
          <app-icon name="shopping-bag" [size]="22"></app-icon>
          <span><small>دریافت از</small><b>کافه بازار</b></span>
        </a>
        <a class="store" routerLink="/download/">
          <app-icon name="apple" [size]="22"></app-icon>
          <span><small>دریافت برای</small><b>آیفون</b></span>
        </a>
        <a class="store" href="https://myket.ir/app/com.baazarplus.app" target="_blank" rel="noopener noreferrer">
          <app-icon name="smartphone" [size]="22"></app-icon>
          <span><small>دریافت از</small><b>مایکت</b></span>
        </a>
      </div>
    </div>
    <div class="app-media">
      <div class="phone iphone">
        <span class="iphone-island" aria-hidden="true"></span>
        <div class="iphone-status" dir="ltr" aria-hidden="true">
          <span class="sb-time">9:41</span>
          <span class="sb-icons">
            <svg width="17" height="11" viewBox="0 0 17 11">
              <rect x="0" y="7" width="3" height="4" rx=".8" fill="currentColor"/>
              <rect x="4.5" y="5" width="3" height="6" rx=".8" fill="currentColor"/>
              <rect x="9" y="2.5" width="3" height="8.5" rx=".8" fill="currentColor"/>
              <rect x="13.5" y="0" width="3" height="11" rx=".8" fill="currentColor"/>
            </svg>
            <svg width="15" height="11" viewBox="0 0 15 11">
              <path fill="currentColor"
                    d="M7.5 2.2c2 0 3.9.8 5.3 2.1l1.1-1.1A9 9 0 0 0 7.5.6 9 9 0 0 0 1.1 3.2l1.1 1.1a7.5 7.5 0 0 1 5.3-2.1Zm0 3.2c1.1 0 2.2.4 3 1.2l1.1-1.1a5.9 5.9 0 0 0-8.2 0l1.1 1.1c.8-.8 1.9-1.2 3-1.2Zm0 3.2c-.4 0-.8.2-1.1.5L7.5 10.2l1.1-1.1c-.3-.3-.7-.5-1.1-.5Z"/>
            </svg>
            <span class="sb-batt"><i></i></span>
          </span>
        </div>
        <div class="iphone-screen">
          <!-- هر صفحه‌نمایش نسخه‌ی هم‌اندازه‌ی خودش را می‌گیرد؛ کوچک کردن تصویر ۵۴۰ پیکسلی
               توسط مرورگر به ۲۳۰ پیکسل متن‌های ریز را مات می‌کرد -->
          <img src="/images/home/app-home-screenshot-460.webp"
               srcset="/images/home/app-home-screenshot-230.webp 230w,
                       /images/home/app-home-screenshot-460.webp 460w,
                       /images/home/app-home-screenshot-540.webp 540w"
               sizes="230px" width="540" height="1136" loading="lazy" decoding="async"
               alt="صفحه اصلی اپلیکیشن بازر">
        </div>
      </div>
    </div>
  </section>

  <!-- سوالات متداول -->
  <section class="faq reveal" id="faq">
    <div class="sec-head">
      <span class="kicker">سوالات متداول</span>
      <h2>هرچه باید دربارهٔ بازر بدانی</h2>
    </div>
    <app-acc-expansion-panel></app-acc-expansion-panel>
  </section>

  <!-- دعوت پایانی -->
  <section class="cta-banner reveal">
    <div class="cta-inner">
      <h2>همین امروز اولین گرم طلایت را بخر</h2>
      <p>ثبت‌نام رایگان است و در کمتر از دو دقیقه انجام می‌شود.</p>
      <a class="btn-gold lg" [href]="registerHref" target="_blank" rel="noopener">رایگان شروع کنید</a>
    </div>
  </section>

</main>
